import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const EntradaSolicitudApp = lazy(() => import('./view/Entrada'))
const EntradaSolicitarRegistroApp = lazy(() => import('./view/EntradaRegistro'))
const EntradaAprobarApp = lazy(() => import('./view/EntradaAprobar'))
const EntradaConsultarApp = lazy(() => import('./view/EntradaConsultar'))
const EntradaConsultarFormApp = lazy(() => import('./view/EntradaConsultarFormulario'))
const EntradaAprobarRegistroApp = lazy(() => import('./view/EntradaAprobarRegistro'))
const EntradaRecepcionApp = lazy(() => import('./view/EntradaRecepcion'))
const EntradaRecepcionRegistroApp = lazy(
  () => import('./view/EntradaRecepcionRegistroV2'),
)
const EntradaActualizarApp = lazy(() => import('./view/EntradaActualizar'))
const EntradaRapidaRegistroApp = lazy(() => import('./view/EntradaRapidaRegistro'))

export const entradaRoutesMap = {
  entrada: {
    path: '/entrada/upsert',
    name: 'Registrar Entrada',
  },
  actualizar: {
    path: '/entrada/actualizar/:id',
    name: 'Actualizar Entrada',
  },
  registro: {
    path: '/entrada/nuevo',
    name: 'Nueva Entrada',
  },
  aprobar: {
    path: '/entrada/aprobar',
    name: 'Aprobar Entrada',
  },
  recepcion: {
    path: '/entrada/recepcion',
    name: 'Recepción Entrada',
  },
  recepcionRegistro: {
    path: '/entrada/recepcion/:id',
    name: 'Registro Recepción Entrada',
  },
  rapida: {
    path: '/entrada/rapida',
    name: 'Registro Entrada Rápida',
  },
  aprobarRegistro: {
    path: '/entrada/aprobarRegistro/:id',
    name: 'Aprobar Entrada',
  },
  consultar: {
    path: '/entrada/consultar',
    name: 'Consultar Entrada',
  },
  consultaForm: {
    path: '/entrada/consultar/:id',
    name: 'Consulta Detallada',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const entradaRoutes = [
  {
    path: entradaRoutesMap.entrada.path,
    element: (
      <OperacionesProvider>
        <EntradaSolicitudApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <EntradaSolicitarRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <EntradaActualizarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.aprobar.path,
    element: (
      <OperacionesProvider>
        <EntradaAprobarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.recepcion.path,
    element: (
      <OperacionesProvider>
        <EntradaRecepcionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.recepcionRegistro.path,
    element: (
      <OperacionesProvider>
        <EntradaRecepcionRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.rapida.path,
    element: (
      <OperacionesProvider>
        <EntradaRapidaRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <EntradaConsultarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.consultaForm.path,
    element: (
      <OperacionesProvider>
        <EntradaConsultarFormApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: entradaRoutesMap.aprobarRegistro.path,
    element: (
      <OperacionesProvider>
        <EntradaAprobarRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default entradaRoutes
